import { render, staticRenderFns } from "./add_staff.vue?vue&type=template&id=1c06222f&scoped=true&"
import script from "./add_staff.vue?vue&type=script&lang=ts&"
export * from "./add_staff.vue?vue&type=script&lang=ts&"
import style0 from "./add_staff.vue?vue&type=style&index=0&id=1c06222f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c06222f",
  null
  
)

export default component.exports